import React, { useEffect, useState, useContext } from 'react';
import { getFiles } from '../../core/services/files';
import { AppContext } from '../../core/Contexts/AppContext';

const Statistics = () => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  useEffect(() => {
    setTitle('სტატისტიკა');
    setImage('../../images/hero-images/pattern-bg-optimized.jpg');
    setHeaderType(1);

    (async () => {
      try {
        const result = await getFiles();
        setFiles(Array.isArray(result) ? result : []);
      } catch {
        setError('Error fetching files');
      }
    })();
  }, []);

  if (!BASE_URL) return <div>Error: API URL not defined.</div>;
  if (error) return <div>Error: {error}</div>;

  const fileCategories = [
    {
      title: 'სამომხმარებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის ანგარიში',
      filter:
        'სამომხმარებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის ანგარიში',
    },
    {
      title:
        'ინდუსტრიულ და სამშენებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის ანგარიში',
      filter:
        'ინდუსტრიულ და სამშენებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის ანგარიში',
    },
    {
      title:
        'ინფორმაცია ავტოსატრანსპორტო საშუალებების ტექნიკურ მომსახურებაზე გაწეული ხარჯების შესახებ (წლიური ჯამურად)',
      filter:
        'ინფორმაცია ავტოსატრანსპორტო საშუალებების ტექნიკურ მომსახურებაზე გაწეული ხარჯების შესახებ (წლიური ჯამურად)',
    },
    {
      title:
        'ინფორმაცია საწვავის მოხმარებაზე გაწეული ხარჯის შესახებ (წლიური ჯამურად)',
      filter:
        'ინფორმაცია საწვავის მოხმარებაზე გაწეული ხარჯის შესახებ (წლიური ჯამურად)',
    },
    {
      title:
        'ოფიციალურ და სამუშაო ვიზიტებზე (ქვეყნის შიგნით და ქვეყნის გარეთ) გაწეული სამივლინებო ხარჯები',
      filter:
        'ოფიციალურ და სამუშაო ვიზიტებზე (ქვეყნის შიგნით და ქვეყნის გარეთ) გაწეული სამივლინებო ხარჯები',
    },
    {
      title:
        'სსიპ ბაზარზე ზედამხედველობის  სააგენტოში დასაქმებულ პირთა შრომის ანაზღაურება',
      filter:
        'სსიპ ბაზარზე ზედამხედველობის  სააგენტოში დასაქმებულ პირთა შრომის ანაზღაურება',
    },
    {
      title:
        'სსიპ ბაზარზე ზედამხედველობის  სააგენტოში დასაქმებულ პირთა ოდენობა',
      filter:
        'სსიპ ბაზარზე ზედამხედველობის  სააგენტოში დასაქმებულ პირთა ოდენობა',
    },
  ];

  return (
    <section className='container'>
      <div className='mb-5 accordion' id='filesAccordion'>
        {fileCategories.map(({ title, filter }, index) => {
          const filteredFiles = files.filter((file) =>
            file.nm.includes(filter)
          );

          // Group files by pageId
          const groupedFiles = filteredFiles.reduce((acc, file) => {
            if (!acc[file.pageId]) {
              acc[file.pageId] = [];
            }
            acc[file.pageId].push(file);
            return acc;
          }, {});

          return (
            <div key={index} className='accordion-item mb-3'>
              <h4 className='accordion-header'>
                <button
                  className={`accordion-button ${
                    activeIndex === index ? '' : 'collapsed'
                  }`}
                  type='button'
                  onClick={() =>
                    setActiveIndex(activeIndex === index ? null : index)
                  }
                  aria-expanded={activeIndex === index}
                >
                  <span className='font__size--18 text__18-1024'>{title}</span>
                  <span
                    className={`arrow-icon ${
                      activeIndex === index ? 'rotate' : ''
                    }`}
                  >
                    ↓
                  </span>
                </button>
              </h4>
              <div
                className={`accordion-collapse collapse ${
                  activeIndex === index ? 'show' : ''
                }`}
              >
                <div className='accordion-body'>
                  {Object.keys(groupedFiles).length ? (
                    Object.entries(groupedFiles).map(([pageId, fileList]) => (
                      <div key={pageId} className='mb-4'>
                        {fileList.map((file, i) => (
                          <a
                            key={i}
                            href={`${BASE_URL}/uploads/page_files/${
                              file.pageId
                            }/${encodeURIComponent(file.file_name)}`}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='wrapper__list-document d-inline-block color__gray-1 my-3'
                          >
                            <div className='d-flex align-items-center j-content-sb'>
                              <div className='ml-3 semi-bold font__size--14 text__13-1024 text-uppercase'>
                                {file.nm}
                              </div>
                              <img src='./../images/pdf (1) 1.png' alt='' />
                            </div>
                          </a>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div>No files found for "{title}".</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Statistics;
